import React from 'react';
import styled from "styled-components";

const SeparatorWrapper = styled.svg`
  display: block;
  background-color: ${(props) => props.bgColor || '#fff' } ;
`;

const PathUp = styled.path`
  opacity: 1;
  fill: #f0a8ae;
`;

const PathDown = styled.path`
  fill: #f1adb2;
`;

const Separator = (props) =>
    <SeparatorWrapper        
        preserveAspectRatio="xMidYMax meet"
        className="svg-separator sep3"
        viewBox="0 0 1600 100"
        data-height="100"
        {...props}
    >
        <PathUp
            d="M-40,83.627C20.307,83.627,20.058,44,80,44s60.003,40,120,40s59.948-40,120-40s60.313,40,120,40s60.258-40,120-40s60.202,40,120,40s60.147-40,120-40s60.513,40,120,40s60.036-40,120-40c59.964,0,60.402,40,120,40s59.925-40,120-40s60.291,40,120,40s60.235-40,120-40s60.18,40,120,40s59.82,0,59.82,0l0.18,14H-60V84L-40,83.627z"
        ></PathUp>
        <PathDown
            d="M-40,95.627C20.307,95.627,20.058,56,80,56s60.003,40,120,40s59.948-40,120-40s60.313,40,120,40s60.258-40,120-40s60.202,40,120,40s60.147-40,120-40s60.513,40,120,40s60.036-40,120-40c59.964,0,60.402,40,120,40s59.925-40,120-40s60.291,40,120,40s60.235-40,120-40s60.18,40,120,40s59.82,0,59.82,0l0.18,138H-60V96L-40,95.627z"
        ></PathDown>
    </SeparatorWrapper>

export default Separator;